import { environment as defaultEnv } from './default-environment';

export const environment = {
  ...defaultEnv,
  backendUri: 'https://sales-de-api.hl-display.com/',
  production: true,
  defaultLanguage: 'de'
};
